<template>
  <MenuButton
    class="relative"
    :variant="count > 0 ? 'accent': 'outline'"
    :title="$t('text-direct-messages')"
    placement="bottom"
    :on-click="handleClick"
  >
    <span class="sr-only">{{ $t('text-direct-messages') }}</span>
    <ChatBubble class="w-6 h-6" />
    <span v-if="count" class="bg-light py-0.5 px-1 text-xs leading-none font-bold text-primary-dark rounded-full absolute top-0 end-0 mt-0 -me-1">
      {{ count }}
    </span>
  </MenuButton>
</template>

<script setup>
import { useAuthStore } from '@stores/auth';
import { useCustomerStore } from '@stores/customer';
import ChatBubble from "@components/icons/outline/chat-bubble";
import MenuButton from "@components/ui/menu-button";

const auth = useAuthStore();
const customer = useCustomerStore();

const count = computed(() => auth?.notificationInfo?.unreadDirectMessagesCount);

const handleClick = async () => {
  await navigatorTo(translatePath(ROUTES.CODE.SUPPLIER, slugify(auth.idSupplier, `${customer.firstName} ${customer.lastName}`)))
}

</script>
